import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const CREATE_REFUND = SERVER_URI + '/refund-reasons';
const GET_REFUND_REASON = SERVER_URI + '/get-refund-reasons';
const CHANGE_PLAY_POINT_STATUS = SERVER_URI + '/refund-reason-status/';
const UPDATE_REFUND_STATUS = SERVER_URI + '/refund-reasons/';

export default {

createRefund:async function(paylaod){
  console.log("DesignationList payload", paylaod)
  return apiPost(CREATE_REFUND,paylaod)
},
getRefundReason: async function (payload) {
    return apiPost(GET_REFUND_REASON,payload);
  },
  changeReasonStatus: async function (id) {
    return apiGet(CHANGE_PLAY_POINT_STATUS + id);

  },
  updateRefundStatus: async function (id,payload) {
    console.log("immd.....", id,payload)
    return apiPut(UPDATE_REFUND_STATUS +id,payload)
  }

};